import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import { GADataProps } from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import PulseEntry from "@features/pulse/components/PulseEntry/PulseEntry";
import { useInjectClientData } from "@hooks/useInjectClientData";
import { useTrimmedBreakingNews } from "@hooks/useTrimmedBreakingNews";
import { AuthorPageData } from "@routes/Author/utils/types";
import BreakingNews from "@routes/Section/components/BreakingNews/BreakingNews";

import AuthorArticles from "./components/AuthorArticles";
import AuthorDetails from "./components/AuthorDetails";

/** The content for the author pages. */
const AuthorPageContent = ({
  profileIds,
  profileDetails,
  articles,
  seoFooterData,
  gaProps,
}: AuthorPageData & { gaProps: GADataProps }): React.ReactElement => {
  const breakingNews = useTrimmedBreakingNews();

  useInjectClientData({ gaProps });

  return (
    <div className="w-full" data-testid="author-page-content">
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <PulseEntry />

      <Container rootClassName="py-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <AuthorDetails {...profileDetails} />

            <AuthorArticles cardProps={articles} profileIds={profileIds} />
          </div>

          <div>
            <div className="mb-6 hidden lg:block lg:h-[800px]">
              <Ad
                adType="imu2"
                className="flex flex-col items-center justify-center lg:!sticky lg:top-18"
              />
            </div>

            <BreakingNews
              data={breakingNews}
              rootClassName="max-w-[300px] mx-auto mb-6"
            />
          </div>
        </div>
      </Container>

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />
      <Ad adType="prestitial" />
    </div>
  );
};

export default AuthorPageContent;
